
import axios from "../../../../utils/axiosInceptor";
import { adminService } from "../../../../configs/constants";

export const getTemplates = async (limit, page,query=null) => {
    try {
      
        let url = `${adminService}/template/list?limit=${limit}&page=${page}`;
        const fullUrl = `${url}&${new URLSearchParams(query).toString()}`;
        const response = await axios.get(fullUrl);
        return response?.data.result;
    } catch (errr) {
        console.log(errr)
    }
};


export const updateTemplates = async (data,type=null) => {

     
    try {
        let url = type ? `${adminService}/updateTemplate/${data?.templateId}` : `${adminService}/createTemplate`;
        const response = type ? await axios.patch(url, data) : await axios.post(url, data);
        return response;
    } catch (errr) {
        console.log(errr)
    }
};